import { values, isEmpty, prop } from 'ramda'

import { defaultStateDataCurrent, type State } from 'app/common/ui-components/filter'
import { GET_BUILDINGS } from 'app/common/api/requests/food/schools/buildings'
import { api } from 'app/api'

import type { FilterParams } from '../../filterCommon/FIlterParams'


const buildingItems = async (_: State, params?: FilterParams) => {
  const orgId: number | undefined = prop('orgId', params || {})

  if (orgId) {
    const res = await api.request(GET_BUILDINGS, {
      error: 'Не удалось получить данные корпусов',
      requestPathParams: {
        orgId,
      },
    })

    if (res && !isEmpty(res)) {
      const items = values(res)
      return ([items, defaultStateDataCurrent])
    }
  }
  return [[], defaultStateDataCurrent]
}

export default buildingItems
